import React, { useState, useEffect } from "react";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { companyInfo } from "./GetCompanyInfo";
import SessionData from "../../services/session-data";

export default function ModifyBranch(props: any) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  let data: companyInfo = props.data;
  const [error, setError] = useState(false);
  let message = "";

  const handleClose = () => {
    setOpen(false);
    props.parentCallback(message);
  };

  useEffect(() => {
    // eslint-disable-next-line no-lone-blocks
    {
      setName(data.name);
      setEmail(data.email);
      props.editOpen ? setOpen(true) : setOpen(false);
    }
  }, []);

  const EditClientInfo = async () => {
    const sd = new SessionData();
    try {
      const res = await axios.put(
        sd.getBaseURL() + "user/companyinfo",
        {
          id: data.id,
          name: name,
          email: email,
        },
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + sd.getClientToken(),
            "staff-auth": "Bearer " + sd.getStaffToken(),
          },
        }
      );
      if (res.status === 201) {
        message = "User Updated";
      }
    } catch (err: any) {
      message = "Something Went Wrong";
    } finally {
      setName("");
      setEmail("");
      handleClose();
    }
  };

  const showTheDialog = () => {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            Edit User Information
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "#eff9f0" }}>
            <DialogContentText>
              {/* showing articles in this load */}
              <form>
                <div className="form-group">
                  <label htmlFor="brnachName">User Name</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    id="name"
                  ></input>
                </div>
                <div className="form-group">
                  <label htmlFor="city">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    id="email"
                  ></input>
                </div>
                {error ? <div>Please fill all the fields</div> : ""}
              </form>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ backgroundColor: "#eff9f0" }}>
            <Button onClick={formValidation} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const formValidation = () => {
    if (name.length <= 0 || email.length <= 0 || data.id <= 0) {
      setError(true);
      return;
    }
    EditClientInfo();
  };

  return <div>{open ? showTheDialog() : ""}</div>;
}
